import { render } from "./IconUser.vue?vue&type=template&id=498b6350"
const script = {}

import "./IconUser.vue?vue&type=style&index=0&id=498b6350&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__